import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./Mgrdetail.css";

export default function JKBDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          JKB – Billboard & Brochure Design
        </h1>

        <p className="project-description">
          We designed and developed high-impact brand communication materials for JKB Housing, creating striking outdoor billboards and a premium corporate brochure. Our design process combined grand-scale visual hierarchy, structured floor plans, and prominent project layouts, successfully showcasing JKB's residential projects across prominent urban routes and detailed print marketing materials.
        </p>

        <div className="project-tags">
          <span className="info-tag">Billboard Design</span>
          <span className="info-tag">Brochure Design</span>
        </div>
      </section>

      {/* 3 Landscape Images */}
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/JKB/Full1.webp" alt="JKB Housing Corporate Showcase 1" />
      </div>

      <div className="project-full-image-section" >
        <img src="https://ascentbw.com/Images/JKB/Full3.webp" alt="JKB Housing Construction Layout" style={{minHeight:"1020px"}} />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed grand-scale outdoor billboards for JKB Housing, engineered to capture attention on key transport routes with clean typography and premium project imagery."
        </div>
      </section>

      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/JKB/Full2.webp" alt="JKB Housing Premium Living Space" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "Our team crafted a premium, high-quality brochure system for JKB, presenting site plans, layout grids, and home floor plans in a beautifully structured print design."
        </div>
      </section>

 

      <RelatedWorks excludePath="/works/jkb" />
      <Footer />
    </div>
  );
}
